import {
  saveAutoUpdateInMemoryTable,
  saveDataInMemoryTable,
  saveStagingStateInMemoryTable,
} from "../../service/sourceServices";
import { SecuritiesInStagingState, SecuritiesValuesState } from "../../service/store/types";

export const saveStagingState = (stagingState: SecuritiesInStagingState) => {
  Excel.run(async (context) => {
    await saveStagingStateInMemoryTable(context, stagingState || {});
    await context.sync();
  });
};

export const saveSentValues = (sentValues: SecuritiesValuesState) => {
  Excel.run(async (context) => {
    await saveDataInMemoryTable(context, sentValues || {});
    await context.sync();
  });
};

export const saveAutoUpdateStatus = (autoUpdateStatus: boolean) => {
  Excel.run(async (context) => {
    saveAutoUpdateInMemoryTable(context, autoUpdateStatus);
    await context.sync();
  });
};
